const Credentials = () =>
  import(/* webpackChunkName: "credentials" */ '@/pages/credentials/index.vue')
const EditCredential = () =>
  import(/* webpackChunkName: "credentials" */ '@/pages/credentials/edit.vue')
const CreateCredential = () =>
  import(/* webpackChunkName: "account" */ '@/pages/credentials/create.vue')

export default {
  path: 'credentials',
  component: {
    name: 'CredentialWrapper',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'Credentials',
      path: '',
      component: Credentials,
      meta: { title: 'nav.Credentials' }
    },
    {
      name: 'EditCredential',
      path: 'edit/:id',
      component: EditCredential,
      meta: { title: 'nav.editCredential' },
      props: true
    },
    {
      name: 'AddCredential',
      path: 'create',
      component: CreateCredential,
      meta: { title: 'nav.addCredential' }
    }
  ]
}
